import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Context } from 'src/app/shared/models/context';
import { EmployeeData, Message } from 'src/app/shared/models/domain';
import { Separation } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
@Component({
  selector: 'app-separation',
  templateUrl: './separation.component.html',
  styleUrls: ['./separation.component.scss']
})
export class SeparationComponent implements OnInit {
  @Input() separation: Separation;
  @Input() context: Context;
  public separationForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public separationType: string;
  public separationId: number;
  public appliedFor: EmployeeData[] = [];

  constructor(
    private separationService: SeparationService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.route.queryParams.subscribe(params => {
      this.separationType = params['type'] || 'RESIGNATION';
      this.separationId = params['sId'];
    });
    this.companyService.getEmployees(this.context?.companyId).subscribe(appliedFor => {
      this.appliedFor = appliedFor;
    });
    this.setSeparationForm(this.separation);
    this.getSeparation();
  }

  public getSeparation() {
    if (this.separationId) {
      this.separationService.getSeparation(this.separationId).subscribe(separation => {
        this.separation = separation;
        this.separationForm.patchValue({
          appliedForId: separation.appliedForId, 
          appliedOn: this.datePipe.transform(separation.appliedOn, 'yyyy-MM-dd'),
          lastWorkingDay: this.datePipe.transform(separation.appliedOn, 'yyyy-MM-dd'),
        });
      });
    }
  }
  public formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }
  
  public setSeparationForm(separation?: Separation) {
    if (!separation)
      separation = {
        id: null,
        appliedOn: null,
        lastWorkingDay: null,
        reason: null,
        remarks: null,
        type: null,
        status: "PENDING",
        disabled: false,
        appliedById: this.context.employeeId,
        appliedBy: null,
        appliedForId: this.separationType === 'TERMINATION' ? null : this.context.employeeId,
        appliedFor: null,
      } as Separation;
    this.separationForm = this.fb.group({
      id: this.fb.control(separation?.id, []),
      appliedOn: this.fb.control(separation?.appliedOn ? this.formatDate(separation?.lastWorkingDay) : this.formatDate(new Date().toISOString()), [Validators.required]),
      lastWorkingDay: this.fb.control(separation?.lastWorkingDay ? this.formatDate(separation?.lastWorkingDay) : this.formatDate(new Date().toISOString()), [Validators.required]),
      reason: this.fb.control(separation?.reason, [Validators.required]),
      remarks: this.fb.control(separation?.remarks, [Validators.required]),
      type: this.fb.control(separation?.type, []),
      disabled: this.fb.control(separation?.disabled, []),
      status: this.fb.control(separation?.status, []),
      appliedById: this.fb.control(separation?.appliedById, [Validators.required]),
      appliedBy: this.fb.control(separation?.appliedBy, []),
      appliedForId: this.fb.control(separation?.appliedForId, [this.separationType === 'TERMINATION' ? Validators.nullValidator : Validators.required]),
      appliedFor: this.fb.control(separation?.appliedFor, []),
    });
    this.separationForm.valueChanges.subscribe(value => this.modified = true);
  }

  get s() {
    return this.separationForm.controls;
  }

  public saveSeparation(): Observable<Message> {
    this.submitted = true;
    this.separationForm.markAllAsTouched();
    if (this.separationForm.valid) {
      const separation = this.separationForm.value as Separation;
      separation.type = this.separationType;
      return this.separationService.createSeparation(separation);
    }
  }
}



